module.exports = __webpack_public_path__ + "static/media/automatedcontent_section2.5bd01e01.png";